import { useNavigate, type NotFoundRouteProps } from "@tanstack/react-router";
import cowLogo from "@/assets/cow-spaceship.svg";
import { Heading1, Paragraph } from "@/components/Typography";
import { Button } from "@/components/ui/button";
import { type FileRoutesByTo } from "@/routeTree.gen";

interface NotFoundComponentProps extends NotFoundRouteProps {
  title?: string;
  message?: string;
  backToPath?: keyof FileRoutesByTo;
  backToText?: string;
}

export function NotFound({
  title = "Page not found.",
  message = "The page you are looking for does not exist.",
  backToPath = "/",
  backToText = "Back to dashboard",
}: NotFoundComponentProps) {
  const navigate = useNavigate();

  return (
    <div className="bg-white min-h-screen flex flex-col">
      <div className="flex-grow-[1]" />
      <div className="flex flex-col items-center flex-shrink-0">
        <img src={cowLogo} alt="Image of a cow and a spaceship" width="185" height="180" />
        <div className="px-2 text-center">
          <Heading1 className="text-2xl">{title}</Heading1>
          <Paragraph className="my-2 block">{message}</Paragraph>
        </div>
        <Button
          className="mt-6 text-md"
          size={"lg"}
          variant={"confirm"}
          onClick={() => {
            void navigate({ to: backToPath, replace: true });
          }}
        >
          {backToText}
        </Button>
      </div>
      <div className="flex-grow-[3]" />
    </div>
  );
}
